import script from "./doctorInfoAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorInfoAdd.vue?vue&type=script&setup=true&lang=js"

import "./doctorInfoAdd.vue?vue&type=style&index=0&id=19cf8055&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19cf8055"]])

export default __exports__